export default __webpack_public_path__ + "static/peapron-e25837726ae3a7e211004b6471a65425.jpg";